import memoizeOne from 'memoize-one';
import { isMobileApp } from 'utils';
export var UI_TYPE;
(function (UI_TYPE) {
    UI_TYPE["Small"] = "small";
    UI_TYPE["Medium"] = "medium";
})(UI_TYPE || (UI_TYPE = {}));
export const get_ui_type = memoizeOne(() => {
    if (isMobileApp()) {
        return UI_TYPE.Small;
    }
    if (location.search.indexOf('medium') !== -1) {
        return UI_TYPE.Medium;
    }
    if (location.search.indexOf('small') !== -1) {
        return UI_TYPE.Small;
    }
    if (screen.width < 1100) {
        return UI_TYPE.Small;
    }
    return UI_TYPE.Medium;
});
export const is_narrow_height_screen = () => {
    return ((get_ui_type() === UI_TYPE.Medium && screen.height < 800) ||
        window.location.search.indexOf('narrow') != -1);
};
export function isMediumUI() {
    return get_ui_type() === UI_TYPE.Medium;
}
export function isSmallUI() {
    return get_ui_type() === UI_TYPE.Small;
}
